export default __webpack_public_path__ + "images/6729132538a52f084db3c31ad90bf119-food_and_drink_tablet-2.webp";